var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListArrow01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 3.5,
    fill: "white",
    stroke: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_482_132",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 8,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5651 18L14.4342 18L14.4342 4L7.56511 4L7.5651 18Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_482_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.77529 5.351L12.5801 10.9153L7.89849 16.6637C7.7671 16.8107 7.69522 17.0014 7.69689 17.1985C7.69547 17.4088 7.77725 17.6111 7.92439 17.7613C7.99651 17.836 8.08281 17.8956 8.17825 17.9366C8.27368 17.9776 8.37633 17.9992 8.48019 18C8.58604 17.9979 8.69042 17.9747 8.78727 17.932C8.88412 17.8892 8.97151 17.8276 9.04439 17.7508L14.2244 11.4396C14.3618 11.2896 14.4372 11.0931 14.4355 10.8897C14.4338 10.6863 14.3551 10.4911 14.2153 10.3434L8.89529 4.2436C8.8243 4.16665 8.73814 4.10524 8.64224 4.06323C8.54634 4.02123 8.44278 3.99954 8.33809 3.99954C8.2334 3.99954 8.12984 4.02123 8.03394 4.06323C7.93804 4.10524 7.85188 4.16665 7.78089 4.2436C7.64225 4.39413 7.56471 4.59095 7.56341 4.79559C7.56212 5.00024 7.63717 5.19802 7.77389 5.3503",
    fill: "#AAAAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListArrow01);
export default __webpack_public_path__ + "static/media/icon-list-arrow-01.1ba9153567c9ff68dc1e7685f849523e.svg";
export { ForwardRef as ReactComponent };